import CONFIG from "config";

export const USER_DATA_STORAGE = "userDataBC-MR";
export const LAST_PATH = "lastPathBC-MR";
export const MONTH_NAMES = [
  "Janv",
  "Fev",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juilet",
  "Aout",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const PAGINATION_SIZE = 10;
export const SEARCH_MIN_CHARTS = 3;

export const DEFAULT_LIST_TYPE_PUCE = [
  { id: 1, label: "SIMPLE", value: "SIMPLE" },
  { id: 2, label: "RFID", value: "RFID" },
];

export const DEFAULT_LIST_CATEGORIE_ANIMALE_OTHER = [{ id: 1, label: "ELEVAGE", value: "ELEVAGE" }];
export const DEFAULT_LIST_CATEGORIE_ANIMALE_CIV = [
  { id: 1, label: "ELEVAGE", value: "ELEVAGE" },
  { id: 2, label: "COMPAGNIE", value: "COMPAGNIE" },
];
const { CODE_CLIENT } = CONFIG;
export const DEFAULT_LIST_CATEGORIE_ANIMALE =
  CODE_CLIENT === "ci" ? DEFAULT_LIST_CATEGORIE_ANIMALE_CIV : DEFAULT_LIST_CATEGORIE_ANIMALE_OTHER;
export const PANEL_MODES = {
  NONE: null,
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
  FILTER: "filter",
};
